module.exports = __webpack_public_path__ + "static/img/9.de70807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/9.png
// module id = jQ9q
// module chunks = 0